import { render, staticRenderFns } from "./DeclarationCotisationPage.vue?vue&type=template&id=d1194500&scoped=true&"
import script from "./DeclarationCotisationPage.vue?vue&type=script&lang=js&"
export * from "./DeclarationCotisationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1194500",
  null
  
)

export default component.exports